var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Topbar", { ref: "topbar" }),
      _c(
        "div",
        { staticClass: "m-auto news-word" },
        [
          _c("Breadcrumb", { ref: "breadcrumb", attrs: { title: "操作手册" } }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "guide-body",
            },
            [
              _vm.guide && _vm.guide.fileUrl
                ? [
                    _vm.isImage
                      ? _c("el-image", {
                          staticStyle: { width: "100%", height: "auto" },
                          attrs: { src: _vm.guide.fileUrl, fit: "contain" },
                        })
                      : _c(
                          "div",
                          { staticClass: "guide-tip" },
                          [
                            _c("p", [
                              _vm._v(
                                "该操作手册为 " +
                                  _vm._s(
                                    _vm.fileExt ? _vm.fileExt.toUpperCase() : ""
                                  ) +
                                  " 格式，请下载后查看。"
                              ),
                            ]),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "small" },
                                on: { click: _vm.download },
                              },
                              [_vm._v("下载并查看")]
                            ),
                          ],
                          1
                        ),
                  ]
                : !_vm.loading
                ? _c("el-empty", {
                    attrs: { description: "当前考试暂未上传操作手册" },
                  })
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }